import { ShoppingAssistantComponent } from './shopping-assistant.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ ShoppingAssistantComponent });
